export const nouns = [
  // 1. Gender
  {
    id: 'noun-maskulin',
    category: 'nomen',
    level: 'A1',
    title: 'Maskulin (der - Mashkullori)',
    detailedContent: `
      <section>
        <p>Gjinia mashkullore (Maskulin) në gjermanisht identifikohet me nyjen e shquar <b>der</b>. Përcaktimi i gjinisë shpesh duhet mësuar përmendësh, por ekzistojnë rregulla dhe grupe fjalësh që janë gjithmonë mashkullore.</p>

        <h3>1. Fjalët që janë gjithmonë Maskulin</h3>
        <ul>
          <li><b>Personat dhe kafshët mashkull:</b> der Mann (burri), der Vater (babai), der Löwe (luani).</li>
          <li><b>Ditët e javës, muajt, stinët:</b> der Montag (e hëna), der Mai (Maji), der Sommer (vera).</li>
          <li><b>Drejtimet e busullës dhe moti:</b> der Norden (veriu), der Regen (shiu), der Schnee (bora).</li>
          <li><b>Markat e makinave:</b> der Audi, der BMW, der Mercedes.</li>
          <li><b>Pijet alkoolike:</b> der Wein (vera), der Wodka (përjashtim bën "das Bier" - birra).</li>
        </ul>

        <h3>2. Prapashtesat (Endungen) tipike për Maskulin</h3>
        <p>Emrat që mbarojnë me këto prapashtesa janë thuajse gjithmonë <b>der</b>:</p>
        <div class="p-4 bg-gray-50 border-l-4 border-yellow-400 my-4 rounded">
          <strong>-er, -ismus, -ist, -ant, -ling, -or, -ent</strong>
        </div>
        <ul>
          <li><b>-er:</b> der Lehrer (mësuesi), der Computer.</li>
          <li><b>-ismus:</b> der Kapitalismus, der Realismus.</li>
          <li><b>-ist / -ant:</b> der Optimist, der Praktikant.</li>
          <li><b>-or / -ent:</b> der Motor, der Student.</li>
        </ul>
      </section>
    `,
    tables: [],
    examples: [
      { ger: 'Der Motor ist laut.', alb: 'Motori është i zhurmshëm. (-or fundore = der)' },
      { ger: 'Der Sommer war sehr heiß.', alb: 'Vera ishte shumë e nxehtë. (Stinët = der)' }
    ],
    exercises: [
      { question: 'Me çfarë nyje fillojnë ditët e javës (Montag, Dienstag)?', options: ['die', 'der', 'das'], correct: 1, explanation: 'Të gjitha ditët e javës, muajt dhe stinët janë gjithmonë të gjinisë mashkullore (der).' }
    ]
  },
  {
    id: 'noun-feminin',
    category: 'nomen',
    level: 'A1',
    title: 'Feminin (die - Femërorja)',
    detailedContent: `
      <section>
        <p>Gjinia femërore (Feminin) mban nyjen <b>die</b> në rastin Nominativ. Rreth 46% e të gjithë emrave në gjermanisht janë femërorë, duke e bërë këtë gjininë më të madhe statistikisht.</p>

        <h3>1. Fjalët që janë gjithmonë Femërore</h3>
        <ul>
          <li><b>Personat dhe kafshët femra:</b> die Frau (gruaja), die Mutter (nëna), die Kuh (lopa). (Përjashtim drastik bën "das Mädchen" - vajza).</li>
          <li><b>Numrat e përdorur si emra:</b> die Eins (njëshi), die Million.</li>
          <li><b>Shumica e luleve dhe pemëve:</b> die Rose, die Eiche.</li>
          <li><b>Emrat e avionëve ose anijeve:</b> die Titanic, die Boeing.</li>
        </ul>

        <h3>2. Prapashtesat (Endungen) magjike për Feminin</h3>
        <p>Gjermanishtja ka disa mbaresa "të arta" që NUK dështojnë kurrë. Nëse një fjalë mbaron me një nga këto, është 100% "die".</p>
        <div class="p-4 bg-gray-50 border-l-4 border-yellow-400 my-4 rounded">
          <strong>-heit, -keit, -ung, -schaft, -tion, -tät, -ik, -ur, -enz</strong>
        </div>
        <ul>
          <li><b>-ung:</b> die Übung (ushtrimi), die Wohnung (bapnesa).</li>
          <li><b>-heit / -keit:</b> die Freiheit (liria), die Möglichkeit (mundësia).</li>
          <li><b>-schaft:</b> die Freundschaft (miqësia), die Mannschaft (ekipi).</li>
          <li><b>-tion / -tät (Fjalë ndërkombëtare):</b> die Information, die Universität.</li>
        </ul>
        <p>Kujdes: Shumica dërrmuese (diku 90%) e fjalëve që mbarojnë me <b>-e</b> janë femërore (die Katze, die Lampe), por ka disa përjashtime (der Junge).</p>
      </section>
    `,
    tables: [],
    examples: [
      { ger: 'Die Wohnung ist sehr groß.', alb: 'Banesa është shumë e madhe. (-ung fundore = die)' },
      { ger: 'Die Universität ist alt.', alb: 'Universiteti është i vjetër. (-tät fundore = die)' }
    ],
    exercises: [
      { question: 'Pse fjala "Gesundheit" (Shëndeti) merr nyjen "die"?', options: ['Sepse përfundon me prapashtesën -heit, që është gjithmonë femërore.', 'Sepse shëndeti është koncept thelbësor.', 'Përjashtim letrar'], correct: 0, explanation: 'Të gjitha fjalët me -heit, -keit, -ung, -schaft marrin gjithmonë nyjen "die".' }
    ]
  },
  {
    id: 'noun-neutrum',
    category: 'nomen',
    level: 'A1',
    title: 'Neutrum (das - Asnjanësi)',
    detailedContent: `
      <section>
        <p>Gjinia asnjanëse (Neutrum) mban nyjen <b>das</b>. Rreth 20% e emrave në gjermanisht i përkasin kësaj kategorie.</p>

        <h3>1. Fjalët që janë gjithmonë das</h3>
        <ul>
          <li><b>Foljet e kthyera në emra (Substantivierte Verben):</b> das Essen, das Lesen, das Schwimmen.</li>
          <li><b>Mbiemrat e kthyer në abstrakte:</b> das Gute (e mira), das Neue (e reja).</li>
          <li><b>Shkronjat e alfabetit:</b> das A, das B.</li>
          <li><b>Shumica e ngjyrave:</b> das Rot, das Blau.</li>
          <li><b>Foshnjat / Të vegjlit:</b> das Baby, das Kind (fëmija).</li>
        </ul>

        <h3>2. Prapashtesat tipike Asnjanëse</h3>
        <p>Këto mbaresa tregojnë automatikisht që një fjalë është "das":</p>
        <div class="p-4 bg-gray-50 border-l-4 border-yellow-400 my-4 rounded">
          <strong>-chen, -lein, -ment, -um, -ma</strong>
        </div>
        <ul>
          <li><b>-chen / -lein (Zvogëluesit):</b> das Mädchen (vajza), das Brötchen (simitja). Ky rregull thye edhe gjininë natyrale! Prandaj vajza është 'das' dhe jo 'die'.</li>
          <li><b>-ment:</b> das Dokument, das Instrument.</li>
          <li><b>-um / -ma:</b> das Museum, das Thema, das Klima.</li>
        </ul>
      </section>
    `,
    tables: [],
    examples: [
      { ger: 'Das Mädchen spielt im Garten.', alb: 'Vajza luan në kopsht. (-chen zvogëluese e theu gjininë natyrale në "das")' },
      { ger: 'Das Museum ist heute geschlossen.', alb: 'Muzeu është i mbyllur sot. (-um = das)' }
    ],
    exercises: [
      { question: 'Pse "Mädchen" (vajzë) është me nyjen "das" dhe jo "die"?', options: ['Sepse shoqëria gjermane...', 'Sepse fjalët që mbarojnë me "-chen" formojnë Diminutiv (formë zvogëluese) dhe ky rregull theu ndikimin e gjinisë biologjike, duke i bërë ASNËJANËSE.', 'Është gabim gramatikor'], correct: 1, explanation: 'Mädchen vjen nga forma e vjetër "die Magd" + "-chen". Cdo fjalë me -chen bëhet automatikisht "das".' }
    ]
  },

  // 2. Numri
  { id: 'singular', category: 'nomen', level: 'A1', title: 'Singular (Njëjësi)', detailedContent: '<p>Forma themelore, tregon praninë vetëm të një sendi apo personi (p.sh. das Buch, ein Buch). Emri në njëjës merr njërën nga thelbet: der, die ose das.</p>', exercises: [] },
  {
    id: 'pluralbildung',
    category: 'nomen',
    level: 'A1',
    title: 'Rregullat e Shumësit (Pluralbildung)',
    detailedContent: `
      <section>
        <p>Është thelbësore të dihet: <b>Në shumës, TË GJITHA emrat marrin nyjen "die", pavarësisht nëse ishin der, die, apo das në njëjës!</b></p>
        <p>Për sa i përket shtesës fundore të fjalës, gjermanishtja nuk shton thjesht një "s" si anglishtja. Çdo fjalë e formon shumësin sipas disa grupeve.</p>
        
        <h3>1. Shumësi me "-e" (shpesh me umlaut)</h3>
        <p>Kryesisht emrat mashkullorë të shkurtër (der) dhe asnjanës.</p>
        <ul>
          <li>der Tag -> die Tag<b>e</b></li>
          <li>der Tisch -> die Tisch<b>e</b></li>
          <li>der Baum (me umlaut) -> die B<b>ä</b>um<b>e</b></li>
        </ul>

        <h3>2. Shumësi me "-n" ose "-en"</h3>
        <p>Ky është shumësi më "mikpritës" për emrat femërorë. Rreth 90% e emrave femëror (die) përdorin këtë shumës.</p>
        <ul>
          <li>die Frau -> die Frau<b>en</b></li>
          <li>die Blume -> die Blume<b>n</b></li>
          <li>die Universität -> die Universität<b>en</b></li>
        </ul>

        <h3>3. Shumësi me "-er" (shpesh me umlaut)</h3>
        <p>Karakteristikë thelbësore për emrat asnjanës (das) me një rrokje.</p>
        <ul>
          <li>das Kind -> die Kind<b>er</b></li>
          <li>das Bild -> die Bild<b>er</b></li>
          <li>das Buch (me umlaut) -> die B<b>ü</b>ch<b>er</b></li>
        </ul>

        <h3>4. Shumësi me "-s"</h3>
        <p>Përdoret për fjalët e huazuara ndërkombëtare, marka, apo shkurtime.</p>
        <ul>
          <li>das Auto -> die Auto<b>s</b></li>
          <li>das Hotel -> die Hotel<b>s</b></li>
          <li>das Foto -> die Foto<b>s</b></li>
        </ul>

        <h3>5. Shumësi pa asnjë mbaresë (Endungslos)</h3>
        <p>Emrat mashkullorë dhe asnjanës që mbarojnë me <b>-er, -el, -en</b> shpesh NUK e ndryshojnë fare formën. Thjesht u vihet "die" para, dhe mund të marrin Umlauf.</p>
        <ul>
          <li>der Lehrer -> <b>die</b> Lehrer (asnjë ndryshim)</li>
          <li>der Apfel -> die <b>Ä</b>pfel (njësoj, por me Umlaut)</li>
        </ul>
      </section>
    `,
    tables: [
      {
        label: 'Përmbledhje e Shumësve',
        headers: ['Grupi', 'Shembull (Njëjës -> Shumës)'],
        rows: [
          ['-e (ose Umlaut + e)', 'der Stuhl -> die Stühle, das Jahr -> die Jahre'],
          ['-n / -en', 'die Tasche -> die Taschen, der Junge -> die Jungen'],
          ['-er (ose Umlaut + er)', 'das Wort -> die Wörter'],
          ['-s', 'der Chef -> die Chefs'],
          ['Pa mbaresë', 'der Koffer -> die Koffer']
        ]
      }
    ],
    examples: [
      { ger: 'Die Lehrer trinken Kaffee.', alb: 'Mësuesit e pijnë kafenë. (Fjala e njëjësit: der Lehrer, bëhet die Lehrer. Asnjë shtesë mbarase në shumës).' }
    ],
    exercises: [
      { question: 'Zgjidhni formën e shumësit për "das Bild" (fotografia/piktura)?', options: ['die Bilde', 'die Bilden', 'die Bilder'], correct: 2, explanation: 'Fjalët "das" të shkurtra kryesisht marrin -er: die Bilder, die Kinder, die Lieder, etj.' }
    ]
  },
  { id: 'plural', category: 'nomen', level: 'A1', title: 'Plural (Shumësi)', detailedContent: '<p>Koncepti i plurialiteti - qe thekson formimin e shumtë. (Lexo "Rregullat e Shumësit" për specifikat).</p>', exercises: [] },

  // 3. Forma të veçanta
  {
    id: 'n-deklination',
    category: 'nomen',
    level: 'B1',
    title: 'N-Deklination (Deklinimi N)',
    detailedContent: `
      <section>
        <p><b>Deklinimi N (n-Deklination)</b> njihet gjerësisht si rregulli i "Emrave të dobët mashkullorë". Pse të dobët? Sepse ata NUK mund të qëndrojnë dot vetëm pa marrë një mbështetëse "-n" ose "-en" posa të dalin nga rasti tyre Nominativ.</p>
        
        <div class="p-4 bg-gray-50 border-l-4 border-yellow-400 my-4 rounded">
          <strong>Rregulli Thelbësor:</strong> Këta emra i shtohet prapashtesa <b>-n</b> ose <b>-en</b> në Gjatë Rastit AKKUSATIV, DATIV dhe GENITIV, madje dhe në njëjës!
        </div>

        <h3>1. Kush i përket Deklinimit N?</h3>
        <p>Me shumë pak përjashtime si <i>das Herz</i> (zemra), kjo i ndodh <b>VETËM emrave MASHKULLORË (der)</b>. Konkretisht:</p>
        <ul>
          <li><b>Emrat mashkullor që mbarojnë me "-e":</b> der Junge (djali), der Kunde (klienti), der Kollege.</li>
          <li><b>Kombësitë me "-e":</b> der Franzose (francezi), der Türke, der Russe.</li>
          <li><b>Profesionet me "-ent", "-ant", "-ist":</b> der Student, der Praktikant, der Polizist, der Journalist.</li>
          <li><b>Disa kafshë:</b> der Bär (ariu), der Affe (majmuni), der Elefant.</li>
          <li><b>Të veçantë historik:</b> der Mensch (njeriu), der Herr (zotëria - merr vetëm -n, "den Herrn"), der Nachbar (fqinji).</li>
        </ul>

        <h3>2. Si zbatohet?</h3>
        <p>Le të marrim "der Junge" dhe t'a vendosim në Akuzativ: "Ich sehe den Junge<b>n</b>".</p>
        <p>Le të marrim "der Student" dhe t'a vendosim në Dativ: "Ich helfe dem Student<b>en</b>".</p>
        <p>Në <b>GENITIV</b> ata nuk e marrin atë "s" si gjithë të tjerët, por marrin prap "-n" ! -> "das Buch des Mensch<b>en</b>".</p>
      </section>
    `,
    tables: [
      {
        label: 'Tabela Krahasuese: N-Deklination (der Student)',
        headers: ['Kasus', 'Njëjësi Normal (p.sh. der Tisch)', 'N-Deklination (der Student)'],
        rows: [
          ['Nominativ (Kush?)', 'der Tisch', 'der Student'],
          ['Akkusativ (Kë?)', 'den Tisch', 'den Student<b>en</b>'],
          ['Dativ (Kujt?)', 'dem Tisch', 'dem Student<b>en</b>'],
          ['Genitiv (I kujt?)', 'des Tisch<b>es</b>', 'des Student<b>en</b>']
        ]
      }
    ],
    examples: [
      { ger: 'Ich kenne den Polizisten.', alb: 'Unë e njoh policin. (Polizist mbaron me -ist, prandaj në akuzativ merr -en: den Polizist-en)' },
      { ger: 'Das ist das Auto des Kunden.', alb: 'Kjo është makina e klientit. (Genitiv i "der Kunde" asht "des Kunden" - jo "des Kundes")' }
    ],
    exercises: [
      { question: 'Rregullo fjalinë: "Ich frage den Kollege."', options: ['Ich frage den Kollegen', 'Ich frage des Kollegen', 'Fjalia është nëregull'], correct: 0, explanation: 'Kollege është emër mashkullor që mbaron në -e => gjendet në N-Deklination. Për rastin Akuzativ duhet të fitojë në fund -n: "den Kollegen".' }
    ]
  },
  {
    id: 'substantivierung-verben',
    category: 'nomen',
    level: 'B2',
    title: 'Substantivierung von Verben (Foljet në Emra)',
    detailedContent: `
      <section>
        <p><b>Nominalizimi / Substantivimi</b> është procesi i krijimit të një emri abstrakt drejtpërsëdrejti nga një folje e gjermanishtes.</p>
        
        <p>Gjermanishtja adhuron t'i transformojë veprimet në emra. Mënyra më e thatë dhe e saktë është:</p>
        <div class="p-4 bg-gray-50 border-l-4 border-yellow-400 my-4 rounded">
          <strong>Rregulli:</strong> Merr foljen thelbësore (Infinitiv) ashtu siç është, shkruaje me shkronjë të MADHE, dhe vëri përpara nyjen asnjëanëse <b>das</b>.
        </div>
        
        <ul>
          <li>kochen (gatuaj) -> <b>das Kochen</b> (gatimi, ose "të gatuarit")</li>
          <li>schwimmen (notoj) -> <b>das Schwimmen</b> (noti)</li>
        </ul>
        <p><i>Beim Lesen brauche ich Ruhe. (Gjatë LAXIMIT kam nevoj për qetësi). "Beim" vjen nga "bei + dem", sepse Lesen është das Lesen Dativ.</i></p>
      </section>
    `,
    exercises: []
  },
  {
    id: 'substantivierung-adjektiven',
    category: 'nomen',
    level: 'B2',
    title: 'Substantivierung von Adjektiven (Mbiemrat në Emra)',
    detailedContent: `
      <section>
        <p>Ky është kthimi i mbiemrave ne koncepte, grupe njerëzish apo gjëra thelbësore, prap duke i shkruar me Shkronjë të Madhe.</p>
        
        <h3>1. Kur theksojnë Njerëz:</h3>
        <p>Ata referojnë "njeriun që mban këtë mbiemër" dhe ndjekin lakimin e mbiemrave (Adjektivdeklination).</p>
        <ul>
          <li>krank (i sëmurë) -> <b>der Kranke</b> (burri i sëmurë / "Sëmbri"), <b>die Kranke</b> (gruaja e sëmurë).</li>
          <li>neu (i ri) -> <b>der Neue</b> (ai i riu), <b>die Neue</b>.</li>
          <li>bekannt (e njohut) -> <b>ein Bekannter</b> (një i njohuri im).</li>
        </ul>

        <h3>2. Kur theksojnë Koncepte / Gjëra të paprekshme (Asnjanëse)</h3>
        <p>Atëherë ato marrin <b>das</b> dhe fundoren -e.</p>
        <ul>
          <li>gut -> <b>das Gute</b> (e mira / mirësia). <i>Das Gute siegt.</i></li>
          <li>wichtig -> <b>das Wichtigste</b> (më e rëndësishmja). <i>Das Wichtigste ist Gesundheit.</i></li>
        </ul>
      </section>
    `,
    exercises: []
  },

  // 4. Wortbildung
  {
    id: 'komposita',
    category: 'nomen',
    level: 'A2',
    title: 'Komposita (Emrat e Përbërë)',
    detailedContent: `
      <section>
        <p>Gjuha gjermane ndoshta njihet më së miri në botë për <b>"Komposita"</b> –aftësinë e gjeniale për të bashkuar fjalë të ndryshme pafundësisht në një megafjalë të vetme pa hapësira.</p>

        <h3>1. Rregulli Themelor i Konstruktimit</h3>
        <p>Dy, tre a pesë emra vihen njerë pas tjetrit. I rëndësishëm është vetëm THELBI GJUHËSOR I FJALËS SË FUNDIT ABSOLUTE.</p>
        <div class="p-4 bg-gray-50 border-l-4 border-yellow-400 my-4 rounded">
          <strong>Rregulli i Gjinisë:</strong> Fjala E FUNDIT në varg e vendos Gjinën, Numrin Shumës dhe Përcaktimin përfundimtar Semantik të Fjalës. (Të parat thjeshtë e përshkruajnë atë fjalë të fundit).
        </div>

        <h3>2. Shembuj tipikë</h3>
        <ul>
          <li>das Haus (shtepia) + <b>die</b> Tür (dera) = <b>die</b> Haustür (dera E shtëpisë)</li>
          <li>der Schreibtisch + die Lampe = <b>die</b> Schreibtischlampe (lampa e tavolinës p. pun)</li>
          <li>die Kinder + <b>das</b> Zimmer = <b>das</b> Kinderzimmer</li>
        </ul>

        <h3>3. Shtesat Bashkuese (Fugen-s)</h3>
        <p>Ndonjëherë, për të lehtësuar theksin dhe rrjedhshmërinë fonetike, shtohet një shkronjë (më së shumti <b>-s-</b> ose <b>-es-</b>) ndërmjet dy fjalëve. Kjo ndodh gati gjithnjë kur mbaron me -ung, -heit, -schaft.</p>
        <ul>
          <li>die Gesundheit (shëndet) + -s- + das System = <b>das Gesundheitssystem</b>.</li>
          <li>die Liebe (dashuria) + -s- + der Brief = <b>der Liebesbrief</b> (letra e dashurisë).</li>
        </ul>
      </section>
    `,
    exercises: []
  },
  {
    id: 'diminutiv',
    category: 'nomen',
    level: 'A2',
    title: 'Diminutiv (-chen / -lein | Zvogëluesit)',
    detailedContent: `
      <section>
        <p>Ashtu siç theksuam, <b>diminutivët</b> ose zvogëluesit në gjermanisht i shndrrojn fjalet në objekte 'te vogla e te lezetshme'.</p>
        <p>Fundoret qe mund t shtohen jane <b>-chen</b> ose jugorja <b>-lein</b>.</p>
        <ul>
          <li>Zanorja rrënjësore gati gjithmon Merr umlaut (a -> ä, o -> ö, u -> ü).</li>
          <li><b>NYJA BEHET GJITHMONE "das".</b></li>
        </ul>
        <p>der Baum (pema) -> das B<b>ä</b>um<b>chen</b> (pema e vogël)</p>
        <p>der Tisch (tavolina) -> das Tischlein</p>
      </section>
    `,
    exercises: []
  }
];
